import { useMutation } from '@tanstack/react-query'
import { ExtendableMutationOptions } from 'shared/api/api.types'
import { CustomEvents } from 'shared/constants/customEvents'
import { LocalStorageKey } from 'shared/constants/localStorage'
import { withAuthStorageReason } from 'shared/services/logger/utils/authDiagnostics'
import { dispatchCustomEvent } from 'shared/utils/customEvents'

import { authApi } from '../..'
import { LogoutRequest, LogoutResponse } from './logout.types'

export const logout = async (request: LogoutRequest) => {
  const response = await authApi.post<LogoutResponse>('/logout', request)
  return response.data
}

export const useLogoutMutation = (
  options?: ExtendableMutationOptions<LogoutResponse, LogoutRequest>
) => {
  return useMutation({
    mutationFn: logout,
    onSuccess: (data, ...args) => {
      withAuthStorageReason('logout_request_completed', () =>
        localStorage.removeItem(LocalStorageKey.USER)
      )
      dispatchCustomEvent(CustomEvents.AUTH_USER_DATA_UPDATED, {
        user: null
      })
      options?.onSuccess?.(data, ...args)
    },
    ...options
  })
}
